import { render, staticRenderFns } from "./statusFilter.vue?vue&type=template&id=b1151da2&"
import script from "./statusFilter.vue?vue&type=script&lang=js&"
export * from "./statusFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports